import * as React from 'react';
import * as styles from './CodeEditor.css';
import { IATooltip } from '../tooltip/Tooltip';
import { IAIcon } from '../icon/Icon';
import { LocalizationService } from '../../services/LocalizationService';
// import Prism from "prismjs";

export interface ITextFieldProps {
  id?: string;
  label?: string;
  code: string;
  required?: boolean;
  placeholder?: string;
  style?: React.CSSProperties;
  highlightColor?: string;
  onChange: (text: string) => void;
}

export interface IState {
  code: string;
}

export class IACodeEditor extends React.Component<ITextFieldProps, IState> {

  constructor(props: ITextFieldProps) {
    super(props);
    this.state = {
      code: this.props.code
    }
  }

  // public componentWillReceiveProps(props: ITextFieldProps): void {
  //   this.setState({ code: props.code });
  // }

  // useEffect(() => {
  //   Prism.highlightAll();
  // }, [props.language, content]);

  public render(): JSX.Element {
    let label;
    if (this.props.label) {
      label = <div style={{ float: "left" }}>{this.props.label}</div>;
      if (this.props.required) {
        label = <div style={{ float: "left" }}>{this.props.label} <span style={{ color: "red" }}>*</span></div>;
      }
    }
    return (
      <div
        className={styles.IA_codeEditor}
        style={this.props.style}>
        {this.props.label &&
          label
        }
        <IATooltip
          content="Tooltip"
          type={"bubble"}
          styles={{
            width: 200,
            textAlign: "left",
            color: "#333333",
          }}
          componentContent={
            <div>{new LocalizationService().strings.Navigator_Admin_CodeEditorWarning}</div>
          }
        >
          <IAIcon
            title="Info"
            size={14}
            color={this.props.highlightColor !== undefined ? this.props.highlightColor : "#03787c"}
            style={{
              float: "left",
              cursor: "pointor",
              marginLeft: 4,
              marginTop: 3,
              height: 13
            }}
          />
        </IATooltip>
        <div className={styles.codeEditContainer}>
          <textarea
            placeholder="alert('Use with care..!');"
            className={styles.codeInput}
            value={this.state.code}
            onChange={(evt) => {
              if (evt && evt.target != null) {
                this.setState({ code: evt.target.value }, () => this.props.onChange(this.state.code));
              }
            }}
            onKeyDown={(evt) => {
              let code = this.state.code,
                selStartPos = evt.currentTarget.selectionStart;
              console.log(evt.currentTarget);
              // handle 4-space indent on
              if (evt.key === "Tab") {
                code =
                  code.substring(0, selStartPos) +
                  "    " +
                  code.substring(selStartPos, code.length);
                evt.currentTarget.selectionStart = selStartPos + 3;
                evt.currentTarget.selectionEnd = selStartPos + 4;
                evt.preventDefault();
                this.setState({ code });
              }
            }}
          />
        </div>
      </div>
    );
  }
}